import { z } from "zod";

import { HotelNotificationSettingInputSchema } from "@/lib/zod/__generated__/validation-schema";

import type { ZodError } from "zod";

const ERROR_MESSAGES = {
	emailMaxLength: "最大3件まで設定できます",
};

/**
 *
 * @description 各メール通知の設定用のバリデーションスキーマ
 */
export const HotelNotificationSettingInputZodSchema = HotelNotificationSettingInputSchema.extend({
	ecNotificationEmails: z.array(z.string().email()).refine((emails) => emails.length <= 3, {
		message: ERROR_MESSAGES.emailMaxLength,
		// 配列全体に対するエラーを保持する箇所が現状存在しないため、
		// 配列の0番目の要素でエラーを保持する
		path: [0],
	}),
	paymentNotificationEmails: z.array(z.string().email()).refine((emails) => emails.length <= 3, {
		message: ERROR_MESSAGES.emailMaxLength,
		// 配列全体に対するエラーを保持する箇所が現状存在しないため、
		// 配列の0番目の要素でエラーを保持する
		path: [0],
	}),
	reservationNotificationEmails: z.array(z.string().email()).refine((emails) => emails.length <= 3, {
		message: ERROR_MESSAGES.emailMaxLength,
		// 配列全体に対するエラーを保持する箇所が現状存在しないため、
		// 配列の0番目の要素でエラーを保持する
		path: [0],
	}),
});

export type HotelNotificationSettingInputZodSchemaType = z.infer<typeof HotelNotificationSettingInputZodSchema>;

export type HotelNotificationSettingInputZodParseError = ZodError<HotelNotificationSettingInputZodSchemaType>;
